import { Component, OnInit } from '@angular/core';
import { PreAuthenticationResponse, LogonResponse, ProfileRequestModel, ResponseBaseModel, PasswordValidationRequestModel } from '@picard/models-lib';
import { BreadcrumbService, ProfileService, ApplicationService } from '@picard/services-lib';
import { SelectItem } from 'primeng/primeng';
import { StorageConstants } from '@picard/shared-lib';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import Swal from 'sweetalert2';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

import moment from 'moment';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  //#region Properties
  titles: SelectItem[];
  communicationMethods: string[];
  preAuthenticationResponse: PreAuthenticationResponse;
  logonResponse: LogonResponse;
  profileFormGroup: FormGroup;
  profileRequestModel: ProfileRequestModel;
  @BlockUI() blockUI: NgBlockUI;
  docTheme = document.getElementById('theme-css');
  docLayout = document.getElementById('layout-css');
  programId: number;
  //#endregion Properties

  //#region Constructor
  constructor(private _breadcrumbService: BreadcrumbService, private _formBuilder: FormBuilder, private _profileService: ProfileService, private _title: Title, private _router: Router, private _applicationService: ApplicationService, private _datePipe: DatePipe) {
    this.programId = parseInt(sessionStorage.getItem('programID')); // this._applicationService.preAuthenticationResponse.programId;
    this.preAuthenticationResponse = JSON.parse(sessionStorage.getItem(StorageConstants.preAuth));
    this._breadcrumbService.setItems([{ label: 'Profile', routerLink: '/profile' }]);

    if (this.docTheme) {
      this.docTheme.setAttribute('href', this.preAuthenticationResponse.programmeAssetsModel.theme);
    }
    if (this.docLayout) {
      this.docLayout.setAttribute('href', this.preAuthenticationResponse.programmeAssetsModel.layout);
    }
  }
  //#endregion Constructor

  //#region Functions
  ngOnInit() {
    const htmlBody: HTMLLinkElement = <HTMLLinkElement>document.getElementById('top-menu');
    // htmlBody.className = 'topbar-menu fadeInDown';
    this.preAuthenticationResponse = JSON.parse(sessionStorage.getItem(StorageConstants.preAuth));
    this._title.setTitle(`${this.preAuthenticationResponse.description} - Profile`);
    this.logonResponse = JSON.parse(sessionStorage.getItem(StorageConstants.loginDetails));
    this.titles = [{ label: '- None -', value: null }, { label: 'Mr', value: 'Mr' }, { label: 'Ms', value: 'Ms' }, { label: 'Mrs', value: 'Mrs' }];
    if (this.logonResponse.usersModel.dateOfBirth) {
      const now = moment(this.logonResponse.usersModel.dateOfBirth).toDate();
      this.profileFormGroup = this._formBuilder.group({
        initials: [this.logonResponse.usersModel.initials],
        firstname: [this.logonResponse.usersModel.firstname],
        surname: [this.logonResponse.usersModel.surname],
        email: [this.logonResponse.usersModel.email],
        mobileNumber: [this.logonResponse.usersModel.mobileNumber],
        dateOfBirth: new FormControl(now)
      });
    } else {
      this.profileFormGroup = this._formBuilder.group({
        initials: [this.logonResponse.usersModel.initials],
        firstname: [this.logonResponse.usersModel.firstname],
        surname: [this.logonResponse.usersModel.surname],
        email: [this.logonResponse.usersModel.email],
        mobileNumber: [this.logonResponse.usersModel.mobileNumber],
        dateOfBirth: new FormControl()
      });
    }
  }
  async saveCommunication() {
    this.profileRequestModel = new ProfileRequestModel();
    this.profileRequestModel.userId = this.logonResponse.usersModel.userId;
    this.profileRequestModel.receiveSms = this.logonResponse.usersModel.receiveSms;
    this.profileRequestModel.receiveEmail = this.logonResponse.usersModel.receiveEmail;
    this.blockUI.start('Updating authentication details.');
    const response: ResponseBaseModel = await this._profileService.UpdatePreferredCommunicationAsync(this.profileRequestModel);
    this.blockUI.stop();
    if (response.isSuccessful) {
      this.handleResponse(response);
      this.updateLogonResponseCacheItem();
    }
  }

  async validatePassword() {
    const { value: currentpassword } = await Swal({
      title: 'Enter current password',
      input: 'text',
      inputAttributes: {
      },
      inputPlaceholder: 'Password...'
    });
    if (currentpassword) {
      if (isNaN(currentpassword)) {
        Swal('Invalid Password: ' + currentpassword, 'Password can not be null, please enter a valid password. Example: 12345', 'error');
      } else {
        var validationModel = new PasswordValidationRequestModel();
        validationModel.privatePassword = btoa(currentpassword);
        this.blockUI.start('Validating password.');
        const response: ResponseBaseModel = await this._profileService.ValidatePasswordAsync(validationModel);
        this.blockUI.stop();
        if (response.isSuccessful) {
          this.handleResponse(response);
          this.changePassword()
        }
        else{
          Swal('Validation Failed: ', response.message, 'error');
        }
      }
    }
  }
  // ToDo: Add a check old password step
  async changePassword() {
    const { value: password } = await Swal({
      title: 'Enter new password',
      input: 'text',
      inputAttributes: {
        maxlength: '5'
      },
      inputPlaceholder: 'New Password...'
    });
    if (password) {
      if (!isNaN(password) && password.length !== 5) {
        Swal('Invalid Password: ' + password, 'The password must be numeric only, and must be 5 characters long. Example: 12345', 'error');
      } else {
        this.profileRequestModel = new ProfileRequestModel();
        this.profileRequestModel.userId = this.logonResponse.usersModel.userId;
        this.profileRequestModel.password = btoa(password);
        this.blockUI.start('Updating password.');
        const response: ResponseBaseModel = await this._profileService.UpdatePasswordAsync(this.profileRequestModel);
        this.blockUI.stop();
        if (response.isSuccessful) {
          this.handleResponse(response);
        }else{
          Swal('Password Update Failed: ', response.message, 'error');
        }
      }
    }
  }
  async updateProfile() {
    this.profileRequestModel = new ProfileRequestModel();
    this.profileRequestModel.userId = this.logonResponse.usersModel.userId;
    this.profileRequestModel.initials = this.profileFormGroup.get('initials').value;
    this.profileRequestModel.firstname = this.profileFormGroup.get('firstname').value;
    this.profileRequestModel.surname = this.profileFormGroup.get('surname').value;
    this.profileRequestModel.email = this.profileFormGroup.get('email').value;
    this.profileRequestModel.mobileNumber = this.profileFormGroup.get('mobileNumber').value;
    this.profileRequestModel.dateOfBirth = this._datePipe.transform(this.profileFormGroup.get('dateOfBirth').value,'yyyy-MM-dd');
    console.log('profileRequestModel:');
    console.log(this.profileRequestModel);
    this.blockUI.start('Updating profile.');
    const response: ResponseBaseModel = await this._profileService.UpdateProfileAsync(this.profileRequestModel);
    this.blockUI.stop();
    this.handleResponse(response);
    this.updateLogonResponseCacheItem();
  }
  
  async deregisterUser() {
    var message = 'Please note, by opting out of our programme any accrued transactional information and data will be deleted in compliance with the Protection of Personal Information Act (POPI Act). Please click “Continue”.';
    if (this.programId == 2492){ message = 'Please note, by opting out of our Liquid Loyalty programme any accrued transactional information and data will be deleted in compliance with the Protection of Personal Information Act (POPI Act).  Please click “Continue”.';}
    
    Swal({
      title: 'Unsubscribe',
      text: message,
      showCloseButton: true,
      confirmButtonText: 'Continue',
    }).then((result) => {
      if (result.value) {
        this.ConfirmDeregistration();
      }
    });
    
  }

  async ConfirmDeregistration(){
    this.blockUI.start('Unsubscribing from loyalty Program...');
    const response: ResponseBaseModel = await this._profileService.DeregisterAsync();
    this.blockUI.stop();
    if (response.isSuccessful) {
      var successMessage = `We're sorry to see you go! You will not receive any promotional messages.`;
      if (this.programId == 2492){ successMessage = `We're sorry to see you go! You will not receive any promotional messages or have the opportunity to redeem sip coins.`;}
      Swal({
        title: 'Unsubscribed',
        text: successMessage,
        showCloseButton: true
      });
      this.onLogoff();
    }else{
      Swal({
        title: 'Unsubscribe',
        text: `Unsubscribe Failed: ${response.message}` ,
        showCloseButton: true,
        type: 'error'
      });
    }
  }

  onLogoff() {
    let route = '';
    // // ToDo: Check the route here once it has been added to the table and the preAuthenticationResponse object.
    // if (this.preAuthenticationResponse.description) {
    //   route = this.preAuthenticationResponse.description;
    // }
    sessionStorage.clear();
    localStorage.clear();
    if (route === '') {
      this._router.navigateByUrl(`/login`);
    } else {
      this._router.navigateByUrl(route);
    }
  }
  handleResponse(response: ResponseBaseModel) {
    if (response.isSuccessful) {
      Swal({ type: 'success', title: response.message, html: '<h3>Changes will reflect the next time you login.</h3>',  showConfirmButton: false, timer: 5000 });
    } else {
      Swal({ type: 'error', title: response.message, showConfirmButton: false, timer: 1500 });
    }
  }
  updateLogonResponseCacheItem() {
    sessionStorage.removeItem(StorageConstants.loginDetails);
    sessionStorage.setItem(StorageConstants.loginDetails, JSON.stringify(this.logonResponse));
  }
  //#endregion Functions
}
